// Số liệu Tổng quan của Mint-HR (script board, khối `HRY`): minh hoạ theo board, không tiền / lương.

export interface DeptStat {
  name: string;
  act: number;
  plan: number;
  mgr: number;
  age: string;
  note: string;
}

export const DEPT_STATS: readonly DeptStat[] = [
  { name: 'Ban giám đốc', act: 2, plan: 2, mgr: 1, age: '46', note: 'DAVID giữ quyền Phó GĐ' },
  { name: 'Kinh doanh', act: 6, plan: 6, mgr: 1, age: '31', note: '' },
  { name: 'Dịch vụ khách hàng', act: 8, plan: 14, mgr: 0, age: '28', note: 'Trống Trưởng phòng + Trưởng nhóm' },
  { name: 'Vận hành', act: 7, plan: 7, mgr: 1, age: '30', note: 'Trưởng phòng kiêm (PHONGNT)' },
  { name: 'Vận tải', act: 10, plan: 13, mgr: 1, age: '38', note: 'Thiếu 2 tài xế + cố vấn kỹ thuật' },
  { name: 'Kế toán', act: 4, plan: 5, mgr: 0, age: '33', note: 'Ghế KTT trống · leo lên BOD-DIR' },
  { name: 'HC–NS–IT', act: 1, plan: 2, mgr: 1, age: '35', note: 'Thiếu CNTT · Trưởng phòng kiêm' },
];

/** Đang làm cuối mỗi tháng 2026 (T1…T10). */
export const HEADCOUNT = [33, 33, 34, 35, 35, 36, 36, 37, 36, 37] as const;
/** [vào, nghỉ] mỗi tháng. */
export const MOVES: ReadonlyArray<readonly [number, number]> = [[2, 1], [1, 1], [2, 1], [1, 0], [1, 1], [2, 1], [1, 1], [2, 1], [0, 1], [2, 1]];
/** Ngày nghỉ đã duyệt theo tháng. */
export const LEAVE_BY_MONTH = [42, 38, 25, 31, 46, 52, 61, 48, 33, 29] as const;
export const TOP_LEAVE: ReadonlyArray<readonly [string, number]> = [['NhiTHT', 11], ['PhuongHT', 9.5], ['HANHLTM', 9], ['NhungTT', 8]];
export const GENDER: ReadonlyArray<readonly [string, number]> = [['Nam', 22], ['Nữ', 15]];
export const AGE_BANDS: ReadonlyArray<readonly [string, number]> = [['< 25', 6], ['25–34', 19], ['35–44', 9], ['≥ 45', 3]];

export interface KpiTile {
  k: string;
  v: string;
  u: string;
  tone?: 'warn';
}
export const OVERVIEW_KPIS: readonly KpiTile[] = [
  { k: 'Đang làm', v: '37', u: 'người · 2 thử việc' },
  { k: 'Sự kiện 30 ngày', v: '7', u: '3 cần lập HĐ / QĐ', tone: 'warn' },
  { k: 'Đơn nghỉ chờ duyệt', v: '3', u: '1 quá 24h', tone: 'warn' },
  { k: 'Ghế trống', v: '4', u: 'KTT · Trưởng CS · TN CS · CNTT', tone: 'warn' },
];

/** KPI của tab Nhân sự (board `K.staff`). */
export const STAFF_KPIS: readonly KpiTile[] = [
  { k: 'Nhân sự đang làm', v: '38', u: 'người' },
  { k: 'Ghế đang kiêm', v: '3', u: 'người giữ 2+ ghế' },
  { k: 'Đang nghỉ hôm nay', v: '2', u: 'MAITTN · TUANNT', tone: 'warn' },
  { k: 'Thử việc', v: '2', u: '1 sắp hết hạn' },
];

/** Tab của Mint-HR: [khoá, nhãn, số, cảnh báo]. Tab Lương thuộc luồng K. */
export const HR_TABS = [
  { key: 'ov', label: 'Tổng quan' },
  { key: 'staff', label: 'Nhân sự', n: 38 },
  { key: 'org', label: 'Cơ cấu & ghế', n: 4 },
  { key: 'time', label: 'Chấm công', n: 2 },
  { key: 'leave', label: 'Nghỉ phép & bàn giao', n: 3 },
  { key: 'ot', label: 'Làm thêm giờ', n: 5 },
  { key: 'pay', label: 'Lương' },
  { key: 'kpi', label: 'KPI' },
  { key: 'rec', label: 'Tuyển dụng', n: 9 },
] as const;
export type HrTab = (typeof HR_TABS)[number]['key'];

/** Điểm đường (khổ 520×132 của board): x chia đều 16…504, y theo min/max. */
export function linePoints(vals: readonly number[], w = 520, h = 132): Array<{ x: number; y: number }> {
  const mx = Math.max(...vals), mn = Math.min(...vals), r = mx - mn || 1;
  const x0 = 16, x1 = w - 16, top = 22, base = h - 22;
  return vals.map((v, i) => ({ x: x0 + (i * (x1 - x0)) / Math.max(1, vals.length - 1), y: base - 6 - ((v - mn) / r) * (base - 6 - top) }));
}

/** KPI của tab Cơ cấu & ghế (board `K.org`). */
export const ORG_KPIS: readonly KpiTile[] = [
  { k: 'Ghế có người', v: '33/37', u: 'định biên' },
  { k: 'Ghế trống', v: '4', u: 'KTT · Trưởng CS · TN CS · CNTT', tone: 'warn' },
  { k: 'Đang kiêm', v: '3', u: 'có phụ cấp' },
  { k: 'Định biên còn thiếu', v: '6', u: 'CS 4 · tài xế 2' },
];

/** Phần của tab Cơ cấu & ghế: [khoá, nhãn, số]. Chỉ "Sơ đồ ghế" mở ở bản này. */
export const ORG_VIEWS = [
  { key: 'map', label: 'Sơ đồ ghế' },
  { key: 'dept', label: 'Phòng ban', n: 11 },
  { key: 'title', label: 'Chức danh', n: 23 },
  { key: 'level', label: 'Bậc L01–L09', n: 9 },
  { key: 'jd', label: 'JD' },
] as const;
